import locale from "locale";

const RECIPIENT_TYPES = [
    {
        label: locale("reminders.application"),
        value: "request",
        disableDuringPreModeration: true,
    },
    {
        label: locale("reminders.refusal"),
        value: "reject",
        disableDuringPreModeration: true,
    },
    {
        label: locale("reminders.viewer"),
        value: "viewer",
    },
    {
        label: locale("reminders.moderator"),
        value: "moderator",
    },
];

const PARTICIPATION_FORMATS = [
    {
        label: locale("reminders.formatAll"),
        value: "null",
    },
    {
        label: locale("reminders.online"),
        value: "online",
    },
    {
        label: locale("reminders.offline"),
        value: "offline",
    },
];

const MAX_SHOW_ROWS = 8;

const REMINDER_TYPES = {
    registered: locale("reminders.registeredType"),
    custom: locale("reminders.customType"),
    statistic: locale("reminders.statisticSourse"),
};

const RECIPIENTS_SOURCES = {
    registered: locale("reminders.registeredSource"),
    custom: locale("reminders.customSource"),
    statistic: locale("reminders.statisticSourse"),
};

const STATUSES = {
    waiting: locale("reminders.statusWaiting"),
    process: locale("reminders.statusProgress"),
    error: locale("reminders.statusError"),
    done: locale("reminders.statusDone"),
};

const MANUAl_MAILING_METHOD = "manual";
const TIME_MAILING_METHOD = "time";
const PERIODIC_MAILING_METHOD = "periodic";

const MAILING_METHODS = [
    {
        label: locale("reminders.manualMailingMethod"),
        value: MANUAl_MAILING_METHOD,
    },
    {
        label: locale("reminders.timeMailingMethod"),
        value: TIME_MAILING_METHOD,
    },
    {
        label: locale("reminders.everydayMailingMethod"),
        value: PERIODIC_MAILING_METHOD,
    },
];

const MEASHURE_TYPE_PERCENTS = "percentage";
const MEASHURE_TYPE_MINUTES = "minute";

const ADDITIONAL_CRITERION_MEASHURES = [
    {
        label: "%",
        value: MEASHURE_TYPE_PERCENTS,
    },
    {
        label: locale("reminders.meashureTypeMinutes"),
        value: MEASHURE_TYPE_MINUTES,
    },
];

const MAIL_SUBJECT_PLACEHOLDERS = [
    "eventName",
    "timeStart",
    "timeStop",
    "dateStart",
    "dateStop",
    "datetimeStart",
    "datetimeStop",
    "userEmail",
];

const MAILING_TYPES = {
    SYSTEM: "registered",
    MANUAL: "custom",
    STATISTIC: "statistic",
};

const RECIPIENTS_LETTER_STATUSES = {
    sent: locale("reminders.sent"),
    error: locale("reminders.notSent"),
    in_queue: locale("reminders.inQueue"),
};

export {
    RECIPIENT_TYPES,
    PARTICIPATION_FORMATS,
    MAX_SHOW_ROWS,
    REMINDER_TYPES,
    RECIPIENTS_SOURCES,
    STATUSES,
    MAILING_METHODS,
    MANUAl_MAILING_METHOD,
    TIME_MAILING_METHOD,
    PERIODIC_MAILING_METHOD,
    ADDITIONAL_CRITERION_MEASHURES,
    MEASHURE_TYPE_PERCENTS,
    MEASHURE_TYPE_MINUTES,
    MAIL_SUBJECT_PLACEHOLDERS,
    MAILING_TYPES,
    RECIPIENTS_LETTER_STATUSES,
};
